import { useEffect, useRef, useState } from "react";
import { Form, Formik, useFormikContext } from "formik";
import * as Yup from "yup";
import { storeIdAction } from "../../../redux/actions/general-action";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import {
  salesDeliveryEditAction,
  salesDeliveryReceiptCreateAction,
} from "../../../redux/actions/sales-action";
import moment from "moment";
import { useHotkeys } from "react-hotkeys-hook";
import { handlea4Print } from "../../helper-components/helper-function";
import SalesPurchaseNavbar from "../sales-purchase-navbar";
import SalesPurchaseFooter from "../sales-purchase-footer";
import SalesItemsSection from "../sales-items-sec";
import SalesBatchesPanel from "../sales-batches-panel";
import LoadingOverlay from "../../helper-components/overlay-loading";

const CreateEditViewSalesDelivery = ({
  isClone = false,
  orderDetail = [],
  vendorDetails = [],
  disabled = false,
  page = "",
  type = "",
  standAlone = false,
  payto,
  shipto,
  itemData,
  pageType,
  clickedplus,
  auto = false,
  isNotViewOnly = true,
  transfer=false
}) => {
  console.log(disabled, "fgdgdfgfdgdfgfdgdfgdg");
  console.log("vendorDetails", vendorDetails);
  // console.log("payto", vendorDetails[0].sott_pay_to_address);
  // console.log("shipto", vendorDetails[0].sott_ship_to_address);
  const [heading, setHeading] = useState([]);
  const searchRef = useRef(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const isDispatchingRef = useRef(false);
  const submitScheduledRef = useRef(false);
  const [tcsTdsAmount, setTcsTdsAmount] = useState("");
  const [addbatch, setAddbatch] = useState(false);
  const [itemId, setItemId] = useState(null);
  const initialData = {
    sl_no: 1,
    item_code: "",
    item_generic_name: "",
    item_name: "",
    item_hsn: "",
    item_manufacturer_name: "",
    item_uom: "",
    item_to_be_delivered: 0,
    quantity: 0,
    item_free_quantity: 0,
    item_batches: [],
    item_discount_amount: 0.0,
    item_total_tax_percentage: 0,
    item_tax_amount: 0,
    item_total_amount: 0,
    item_id: "",
    instock: true,
    item_gst: 0,
    item_sgst: 0,
    item_cgst: 0,
    item_igst:0,
    item_uom_id: "",
    item_manufacturer_id: "",
    // base_quantity: 0,
    pot_id: null,
    pos_id: null,
    base_quantity: 1,
    base_ref_id: null,
    base_ref_type: null,
    base_ref_line_id: null,
    base_ref_doc_number: null,
  };
  const [storeDetails, setStoreDetails] = useState({});
  const initialFormValues = {
    cmr_code: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_code ?? "",
          value: vendorDetails?.[0]?.cmr_id ?? "",
        }
      : "",
    cmr_name: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_name,
          value: vendorDetails?.[0]?.cmr_id,
        }
      : "",
    cmr_id: vendorDetails?.[0]?.cmr_id,
    is_inter_state:vendorDetails?.[0]?.gst_type === "Inter"?true:vendorDetails?.[0]?.gst_type === "Intra"?false:null,
    cmr_phone_number: vendorDetails?.[0]?.cmr_phone_number ?? "",
    remarks: vendorDetails?.[0]?.remarks ?? "",
    // customer_invoice_number: vendorDetails?.[0]?.customer_invoice_number ?? null,
    ...(vendorDetails?.[0]?.sodtt_id
      ? { sodtt_id: vendorDetails?.[0]?.sodtt_id }
      : {}),
    sodtt_order_date: vendorDetails?.[0]?.sodtt_document_date && !isClone
      ? moment(vendorDetails?.[0]?.sodtt_document_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    sodtt_document_date: vendorDetails?.[0]?.sodtt_document_date && !isClone
      ? moment(vendorDetails?.[0]?.sodtt_document_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    sodtt_reference_invoice_date: vendorDetails?.[0]?.sodtt_reference_invoice_date && !isClone
      ? moment(vendorDetails?.[0]?.sodtt_reference_invoice_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    cmr_gstin: vendorDetails?.[0]?.cmr_gstin ?? "",
    sodtt_delivery_date: vendorDetails?.[0]?.sodtt_delivery_date && !isClone
      ? moment(vendorDetails?.[0]?.sodtt_delivery_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    // pot_id: vendorDetails?.[0]?.pot_id ?? null,
    // pos_id: vendorDetails?.[0]?.pos_id ?? null,
    pot_id: itemData?.[0]?.pot_id ?? null,
    pos_id: itemData?.[0]?.pos_id ?? null,
    cmr_tcs: "",
    cmr_tds: "",
    sodtt_sub_total: isClone
      ? 0
      : vendorDetails?.[0]?.sodtt_sub_total || "0.00",
    sodtt_total_discount: isClone
      ? 0
      : vendorDetails?.[0]?.sodtt_total_discount ?? 0,
    sodtt_total_gst: isClone
      ? 0
      : vendorDetails?.[0]?.sodtt_total_gst || "0.00",
    sodtt_round_off_value: vendorDetails?.[0]?.sodtt_round_off_value || "0.00",
    sodtt_total_amount: isClone
      ? 0
      : vendorDetails?.[0]?.sodtt_total_amount || "0.00",
    sodtt_tcs_or_tds_percentage_id:
      vendorDetails?.[0]?.tcs_or_tds_percentage_id ?? "",
    sodtt_tcs_or_tds_percentage: vendorDetails?.[0]?.tcs_or_tds_percentage ?? 0,
    sodtt_tds_tcs_type: vendorDetails?.[0]?.tds_tcs_type ?? "",
    sodtt_tcs_or_tds_amount: vendorDetails?.[0]?.tcs_or_tds_amount ?? 0,
    sodtt_order_status: vendorDetails?.[0]?.sodtt_order_status ?? "",
    sodtt_is_invoice_dis_percentage:
      vendorDetails?.[0]?.sodtt_is_invoice_dis_percentage ?? true,
    sodtt_invoice_discount: vendorDetails?.[0]?.sodtt_invoice_discount ?? 0,
    sodtt_invoice_discount_percentage:
      vendorDetails?.[0]?.sodtt_invoice_discount_percentage ?? 0,
    sodtt_pay_to_address: payto, //new
    sodtt_ship_to_address: shipto, //new
    header_dis_per: "",
    header_inv_dis_per: vendorDetails?.[0]?.sodtt_is_invoice_dis_percentage
      ? vendorDetails?.[0]?.sodtt_invoice_discount_percentage
      : vendorDetails?.[0]?.sodtt_invoice_discount,
    data: [
      ...orderDetail?.map((item, index) => ({
        sl_no: index + 1,
        item_code: item?.item_code,
        item_generic_name: item?.item_generic_name,
        item_name: item?.item_name,
        item_hsn: item?.item_hsn,
        item_manufacturer_name: item?.item_manufacturer_name,
        item_uom: item?.item_uom ?? "--",
        item_to_be_delivered: item?.item_to_be_delivered,
        quantity: type === "sales" ? 0 : item?.item_quantity ?? 0,
        item_free_quantity: parseInt(item?.item_free_quantity ?? 0) ?? 0,
        item_batches: isClone
          ? []
          : item?.itemBatchData?.map((batch) => ({
              item_batch_number: batch?.item_batch_number ?? 0,
              gst_type:vendorDetails?.[0]?.gst_type,
              item_batch_quantity: parseInt(batch?.item_batch_quantity) || 0,
              item_batch_free_quantity:
                parseInt(batch?.item_batch_free_quantity) || 0,
              item_batch_sales_rate:
                parseFloat(batch?.item_batch_sales_rate) || 0,
              item_batch_total_base_sales_rate:
                parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
              item_batch_discount_percentage:
                parseFloat(batch?.item_batch_discount_percentage) || 0,
              item_batch_discount_amount:
                parseFloat(batch?.item_batch_discount_amount) || 0,
              item_batch_discounted_sales_rate:
                parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
              item_batch_tax_percentage:
                parseFloat(batch?.item_batch_tax_percentage) || 0,
              item_batch_tax_amount:
                parseFloat(batch?.item_batch_tax_amount) || 0,
              item_batch_final_sales_rate:
                parseFloat(batch?.item_batch_final_sales_rate) || 0,
              item_batch_total_sales_rate:
                parseFloat(batch?.item_batch_total_sales_rate) || 0,
              item_batch_unit_price:
                parseFloat(batch?.item_batch_unit_price) || 0,
                item_batch_cgst_percentage:(batch?.item_batch_cgst_percentage||0),
                  item_batch_sgst_percentage:(batch?.item_batch_sgst_percentage||0),
                  item_batch_igst_percentage:(batch?.item_batch_igst_percentage||0),
                  item_batch_cgst_amount:(batch?.item_batch_cgst_amount||0),
                  item_batch_sgst_amount:(batch?.item_batch_sgst_amount||0),
                  item_batch_igst_amount:(batch?.item_batch_igst_amount||0),
              item_batch_ptr_amount:
                  parseFloat(batch?.item_batch_ptr_amount) || 0,
              item_batch_pts:
                  parseFloat(batch?.item_batch_pts_amount) || 0,
              item_exp_date: batch?.item_exp_date
                ? moment(batch?.item_exp_date).format("YYYY-MM-DD")
                : "1970-01-01", // Default to a date if not provided
              item_id: batch?.item_id ?? 0,
              from_bin_location: batch?.from_bin_location ?? "",
              from_bin_id: batch?.from_bin_id ?? 0,
              item_batch_avail_quantity:
                parseInt(batch?.item_batch_quantity) ?? 0,
            })),
        item_discount_amount:
          type === "sales" || isClone ? 0 : item?.item_discount_amount,
        item_total_tax_percentage:
          type === "sales" || isClone ? 0 : item?.item_total_tax_percentage,
        item_tax_amount:
          type === "sales" || isClone ? 0 : item?.item_tax_amount ?? 0,
        item_total_amount:
          type === "sales" || isClone ? 0 : item?.item_total_amount,
        item_id: item?.item_id,
        sott_id: item?.sott_id ?? null,
        ...(item?.srt_id && type === "return"
          ? { srt_id: item?.srt_id }
          : { srt_id: null }),
        base_ref_id: item?.sott_id ?? item?.srt_id ?? null,
        base_ref_type: item?.ref_type ?? null,
        base_ref_line_id: item?.item_id ?? null,
        base_ref_doc_number: item?.ref_doc_number ?? null,
        instock: true,
        item_gst:item?.item_gst,
        item_cgst:item?.item_cgst,
        item_sgst:item?.item_sgst,
        item_igst:item?.item_igst,
        uom_dropdown: item?.uom_dropdown
          ? item?.uom_dropdown.map((uom) => ({
              item_uom_id: uom?.item_id,
              label: uom?.alt_uom,
              value: uom?.alt_uom,
              base_quantity: uom?.base_quantity ?? 1,
            }))
          : [],
        item_uom_id: item?.item_uom_id ?? "",
        item_manufacturer_id: item?.item_manufacturer_id ?? "",
        pot_id: item?.pot_id ?? null,
        pos_id: item?.pos_id ?? itemData?.[0]?.pos_id ?? shipto?.store_id ?? null,
        base_quantity: item?.base_quantity ?? 1,
      })),
      initialData,
    ],
  };
  const [initialValue, setInitialValue] = useState(initialFormValues);
  const [reload, setReload] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [storeId, setStoreId] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    cmr_code: Yup.object().required("Customer code number is required"),
    cmr_name: Yup.object().required("Customer name is required"),
  });
  useEffect(() => {
    dispatch(storeIdAction(onSuccessStore, onErrorStore));
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const salesdata = parsed.find((obj) => obj?.sales_delivery_create);
      if (salesdata?.sales_delivery_create) {
        const cols = [...salesdata.sales_delivery_create];
        if (!cols.some((c) => c.value === "item_pack_size")) {
          const qtyIdx = cols.findIndex((c) => c.value === "quantity");
          const insertAt = qtyIdx !== -1 ? qtyIdx + 1 : cols.length;
          cols.splice(insertAt, 0, {
            label: "Unit Qty",
            value: "item_pack_size",
            minWidth: 80,
            alignment: "right",
          });
        }
        setHeading(cols);
      }
    }
  }, []);
  const onSuccessStore = (data) => {
    setStoreId(data?.data?.store_id);
    setReload(!reload);
  };
  const onErrorStore = () => {};
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
    const storeData=data?.data;
    const storeState=storeData?.store_state;
    const store_state=storeState?.toLowerCase()?.trim();
    if(store_state===null || store_state===undefined || store_state?.trim()===""){
        errorToast("Please configure store state in store deatils");
    }
  };
  const onErrorStoreDetails = () => {};

  // const handleSubmit = (values, actions) => {
  //   console.log(values, "fggdfgdfgdgdfgdfgdfgfdgdg");
  //   const missingUOM = values?.data
  //     ?.slice(0, -1)
  //     .some((item) => !item.item_uom);
  //   if(!values?.sodtt_pay_to_address){
  //     errorToast("Please verify and save the address");
  //         return;
  //   }
  //   if(!values?.sodtt_ship_to_address){
  //     errorToast("Please verify and save the address");
  //         return;
  //   }
  //   if (
  //     page === "edit"
  //   ) {
  //     setButtonLoading(true);
  //     const data = {
  //       orderData: {
  //         is_draft_order: values.submittedButton === "draft",
  //         store_id: storeId,
  //         ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
  //         sodtt_total_gst: values?.sodtt_total_gst,
  //         sodtt_total_discount: values?.sodtt_total_discount,
  //         sodtt_payment_status: "paid",
  //         sodtt_transaction_id: "",
  //         sodtt_billing_address: "",
  //         sodtt_total_amount: values?.sodtt_total_amount,
  //         sodtt_sub_total: values?.sodtt_sub_total,
  //         cmr_code: values?.cmr_code?.label,
  //         cmr_id: values?.cmr_id,
  //         cmr_name: values?.cmr_name?.label,
  //         remarks: values?.remarks,
  //         sodtt_order_date: values?.sodtt_order_date,
  //         sodtt_document_date: values?.sodtt_document_date,
  //         sodtt_delivery_date: values?.sodtt_delivery_date,
  //         pot_id: values?.pot_id ?? null,
  //         pos_id: values?.pos_id ?? null,
  //         sodtt_round_off_value: values?.sodtt_round_off_value,
  //         sodtt_tcs_or_tds_percentage_id:
  //           values?.sodtt_tcs_or_tds_percentage_id ?? "",
  //         sodtt_tcs_or_tds_percentage:
  //           values?.sodtt_tcs_or_tds_percentage ?? 0,
  //         sodtt_tds_tcs_type: values?.sodtt_tds_tcs_type ?? "",
  //         sodtt_tcs_or_tds_amount:
  //           values?.sodtt_tcs_or_tds_amount ?? 0,
  //         sodtt_is_invoice_dis_percentage:
  //           values?.sodtt_is_invoice_dis_percentage,
  //         sodtt_invoice_discount:
  //           Number(values?.sodtt_invoice_discount) ?? 0,
  //         sodtt_invoice_discount_percentage:
  //           Number(values?.sodtt_invoice_discount_percentage) ?? 0,
  //         sodtt_pay_to_address: values?.sodtt_pay_to_address || null,
  //         sodtt_ship_to_address: values?.sodtt_ship_to_address || null,
  //       },

  //       itemData: values?.data
  //         ?.slice(0, -1)
  //         .map((item) => ({
  //           item_code: item?.item_code,
  //           item_generic_name: item?.item_generic_name,
  //           item_name: item?.item_name,
  //           item_hsn: item?.item_hsn,
  //           ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
  //           item_quantity: parseInt(item?.quantity),
  //           item_delivered_quantity: parseInt(item?.quantity),
  //           item_free_quantity: item?.item_batches?.reduce(
  //             (sum, batch) =>
  //               sum + (parseInt(batch?.item_batch_free_quantity, 10) || 0),
  //             0
  //           ),
  //           item_batch_number: item?.item_batch_number,
  //           item_schedule: item?.item_schedule,
  //           item_discount_amount: parseFloat(item?.item_discount_amount),
  //           item_total_tax_percentage: item?.item_total_tax_percentage,
  //           item_tax_amount: parseFloat(item?.item_tax_amount),
  //           item_total_amount: item?.item_total_amount,
  //           item_id: item?.item_id,
  //           sott_id: item?.sott_id ?? null,
  //           srt_id: item?.srt_id ?? null,
  //           item_gst: parseFloat(item?.item_gst),
  //           item_sgst: parseFloat(item?.item_sgst||0),
  //           item_cgst: parseFloat(item?.item_cgst||0),
  //           item_uom_id: item?.item_uom_id ?? "",
  //           item_uom: item?.item_uom ?? "",
  //           item_manufacturer_id: item?.item_manufacturer_id ?? "",
  //           item_manufacturer_name: item?.item_manufacturer_name ?? "",
  //           pot_id: item?.pot_id ?? null,
  //           pos_id: item?.pos_id ?? null,
  //         })),

  //       itemBatchData: values?.data
  //         ?.slice(0, -1)
  //         .flatMap((item) =>
  //           item?.item_batches?.map((batch) => ({
  //             item_batch_number: batch?.item_batch_number,
  //             item_batch_quantity: parseInt(batch?.item_batch_quantity),
  //             item_batch_free_quantity: parseInt(batch?.item_batch_free_quantity),
  //             item_batch_sales_rate: parseFloat(batch?.item_batch_sales_rate),
  //             ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
  //             item_batch_total_base_sales_rate:
  //               parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
  //             item_batch_discount_percentage:
  //               batch?.item_batch_discount_percentage,
  //             item_batch_discount_amount: parseFloat(
  //               batch?.item_batch_discount_amount
  //             ),
  //             item_batch_discounted_sales_rate:
  //               parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
  //             item_batch_tax_percentage: batch?.item_batch_tax_percentage,
  //             item_batch_tax_amount: parseFloat(batch?.item_batch_tax_amount),
  //             item_batch_final_sales_rate: parseFloat(
  //               batch?.item_batch_final_sales_rate
  //             ),
  //             item_batch_total_sales_rate: parseFloat(
  //               batch?.item_batch_total_sales_rate
  //             ),
  //             item_batch_unit_price: parseFloat(
  //               batch?.item_batch_unit_price
  //             ),
  //             item_exp_date: batch?.item_exp_date,
  //             item_id: batch?.item_id,
  //             from_bin_location: batch?.from_bin_location,
  //             from_bin_id: batch?.from_bin_id,
  //             item_uom: item?.item_uom ?? "",
  //             item_uom_id: item?.item_uom_id ?? "",
  //           })) || []
  //         ),
  //     };

  //     dispatch(
  //       salesDeliveryEditAction(
  //         data,
  //         onSuccessOrder,
  //         onErrorOrder
  //       )
  //     );
  //   } else {
  //     if (
  //       values?.data
  //         ?.slice(0, -1)
  //         .some(
  //           (item) => parseInt(item.quantity) === 0 || item.quantity === ""
  //         ) &&
  //       values?.submittedButton !== "draft"
  //     ) {
  //       errorToast("Quantity cannot be zero");
  //     } else if (missingUOM && values?.submittedButton !== "draft") {
  //       errorToast("Please add UOM for all items");
  //     } else {
  //       if (values?.data?.length > 1) {
  //         setButtonLoading(true);
  //         setTimeout(() => {
  //           const data = {
  //             orderData: {
  //               is_draft_order: values.submittedButton === "draft",
  //               store_id: storeId,
  //               ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
  //               sodtt_total_gst: values?.sodtt_total_gst,
  //               sodtt_total_discount: values?.sodtt_total_discount,
  //               sodtt_payment_status: "paid",
  //               sodtt_transaction_id: "",
  //               sodtt_billing_address: "",
  //               sodtt_total_amount: values?.sodtt_total_amount,
  //               sodtt_sub_total: values?.sodtt_sub_total,
  //               cmr_code: values?.cmr_code?.label,
  //               cmr_id: values?.cmr_id,
  //               cmr_name: values?.cmr_name?.label,
  //               remarks: values?.remarks,
  //               sodtt_order_date: values?.sodtt_order_date,
  //               sodtt_document_date: values?.sodtt_document_date,
  //               sodtt_delivery_date: values?.sodtt_delivery_date,
  //               pot_id: values?.pot_id ?? null,
  //               pos_id: values?.pos_id ?? null,
  //               sodtt_round_off_value: values?.sodtt_round_off_value,
  //               sodtt_tcs_or_tds_percentage_id:
  //                 values?.sodtt_tcs_or_tds_percentage_id ?? "",
  //               sodtt_tcs_or_tds_percentage:
  //                 values?.sodtt_tcs_or_tds_percentage ?? 0,
  //               sodtt_tds_tcs_type: values?.sodtt_tds_tcs_type ?? "",
  //               sodtt_tcs_or_tds_amount:
  //                 values?.sodtt_tcs_or_tds_amount ?? 0,
  //               sodtt_is_invoice_dis_percentage:
  //                 values?.sodtt_is_invoice_dis_percentage,
  //               sodtt_invoice_discount:
  //                 Number(values?.sodtt_invoice_discount) ?? 0,
  //               sodtt_invoice_discount_percentage:
  //                 Number(values?.sodtt_invoice_discount_percentage) ?? 0,
  //               sodtt_pay_to_address: values?.sodtt_pay_to_address || null,
  //               sodtt_ship_to_address: values?.sodtt_ship_to_address || null,
  //             },

  //             itemData: values?.data
  //               ?.slice(0, -1)
  //               .map((item) => ({
  //                 item_code: item?.item_code,
  //                 item_generic_name: item?.item_generic_name,
  //                 item_name: item?.item_name,
  //                 item_hsn: item?.item_hsn,
  //                 item_quantity: parseInt(item?.quantity),
  //                 item_delivered_quantity: parseInt(item?.quantity),
  //                 item_free_quantity: item?.item_batches?.reduce(
  //                   (sum, batch) =>
  //                     sum + (parseInt(batch.item_batch_free_quantity, 10) || 0),
  //                   0
  //                 ),
  //                 item_batch_number: item?.item_batch_number,
  //                 item_schedule: item?.item_schedule,
  //                 item_discount_amount: parseFloat(item?.item_discount_amount),
  //                 item_total_tax_percentage: item?.item_total_tax_percentage,
  //                 item_tax_amount: parseFloat(item?.item_tax_amount),
  //                 item_total_amount: item?.item_total_amount,
  //                 item_id: item?.item_id,
  //                 sott_id: item?.sott_id ?? null,
  //                 srt_id: item?.srt_id ?? null,
  //                 item_gst: parseFloat(item?.item_gst),
  //                 item_sgst: parseFloat(item?.item_sgst||0),
  //                 item_cgst: parseFloat(item?.item_cgst||0),
  //                 item_uom_id: item?.item_uom_id ?? "",
  //                 item_uom: item?.item_uom ?? "",
  //                 item_manufacturer_id: item?.item_manufacturer_id ?? "",
  //                 item_manufacturer_name: item?.item_manufacturer_name ?? "",
  //                 pot_id: item?.pot_id ?? null,
  //                 pos_id: item?.pos_id ?? null,
  //               })),

  //             itemBatchData: values?.data
  //               ?.slice(0, -1)
  //               .flatMap((item) =>
  //                 item.item_batches.map((batch) => ({
  //                   item_batch_number: batch?.item_batch_number,
  //                   item_batch_quantity: parseInt(batch?.item_batch_quantity),
  //                   item_batch_free_quantity: parseInt(
  //                     batch?.item_batch_free_quantity
  //                   ),
  //                   item_batch_sales_rate: parseFloat(
  //                     batch?.item_batch_sales_rate
  //                   ),
  //                   item_batch_total_base_sales_rate:
  //                     parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
  //                   item_batch_discount_percentage:
  //                     batch?.item_batch_discount_percentage,
  //                   item_batch_discount_amount: parseFloat(
  //                     batch?.item_batch_discount_amount
  //                   ),
  //                   item_batch_discounted_sales_rate:
  //                     parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
  //                   item_batch_tax_percentage:
  //                     batch?.item_batch_tax_percentage,
  //                   item_batch_tax_amount: parseFloat(
  //                     batch?.item_batch_tax_amount
  //                   ),
  //                   item_batch_final_sales_rate: parseFloat(
  //                     batch?.item_batch_final_sales_rate
  //                   ),
  //                   item_batch_total_sales_rate: parseFloat(
  //                     batch?.item_batch_total_sales_rate
  //                   ),
  //                   item_batch_unit_price: parseFloat(
  //                     batch?.item_batch_unit_price
  //                   ),
  //                   item_exp_date: batch?.item_exp_date,
  //                   item_id: batch?.item_id,
  //                   from_bin_location: batch?.from_bin_location,
  //                   from_bin_id: batch?.from_bin_id,
  //                   item_uom: item?.item_uom ?? "",
  //                   item_uom_id: item?.item_uom_id ?? "",
  //                 }))
  //               ),
  //           };

  //           dispatch(
  //             salesDeliveryReceiptCreateAction(
  //               data,
  //               onSuccessOrder,
  //               onErrorOrder
  //             )
  //           );

  //           // dispatch(
  //           //   salesDeliveryReceiptCreateAction(
  //           //     {
  //           //       orderData: {
  //           //         is_draft_order:
  //           //           values.submittedButton === "draft" ? true : false,
  //           //         store_id: storeId,
  //           //         ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
  //           //         sodtt_total_gst: values?.sodtt_total_gst,
  //           //         sodtt_total_discount: values?.sodtt_total_discount,
  //           //         sodtt_payment_status: "paid",
  //           //         sodtt_transaction_id: "",
  //           //         sodtt_billing_address: "",
  //           //         sodtt_total_amount: values?.sodtt_total_amount,
  //           //         sodtt_sub_total: values?.sodtt_sub_total,
  //           //         cmr_code: values?.cmr_code?.label,
  //           //         cmr_id: values?.cmr_id,
  //           //         cmr_name: values?.cmr_name?.label,
  //           //         remarks: values?.remarks,
  //           //         sodtt_order_date: values?.sodtt_order_date,
  //           //         sodtt_document_date: values?.sodtt_document_date,
  //           //         sodtt_delivery_date: values?.sodtt_delivery_date,
  //           //         pot_id: values?.pot_id ?? null,
  //           //         pos_id: values?.pos_id ?? null,
  //           //         sodtt_round_off_value: values?.sodtt_round_off_value,
  //           //         sodtt_tcs_or_tds_percentage_id:
  //           //           values?.sodtt_tcs_or_tds_percentage_id ?? "",
  //           //         sodtt_tcs_or_tds_percentage:
  //           //           values?.sodtt_tcs_or_tds_percentage ?? 0,
  //           //         sodtt_tds_tcs_type: values?.sodtt_tds_tcs_type ?? "",
  //           //         sodtt_tcs_or_tds_amount:
  //           //           values?.sodtt_tcs_or_tds_amount ?? 0,
  //           //         // customer_invoice_number: values?.customer_invoice_number,
  //           //         sodtt_is_invoice_dis_percentage:
  //           //           values?.sodtt_is_invoice_dis_percentage,
  //           //         sodtt_invoice_discount:
  //           //           Number(values?.sodtt_invoice_discount) ?? 0,
  //           //         sodtt_invoice_discount_percentage:
  //           //           Number(values?.sodtt_invoice_discount_percentage) ?? 0,
  //           //         sodtt_pay_to_address: values?.sodtt_pay_to_address || null, //new
  //           //         sodtt_ship_to_address:
  //           //           values?.sodtt_ship_to_address || null, //new
  //           //       },
  //           //       itemData: values?.data?.slice(0, -1).map((item, index) => ({
  //           //         item_code: item?.item_code,
  //           //         item_generic_name: item?.item_generic_name,
  //           //         item_name: item?.item_name,
  //           //         item_hsn: item?.item_hsn,
  //           //         item_quantity: parseInt(item?.quantity),
  //           //         item_delivered_quantity: parseInt(item?.quantity),
  //           //         item_free_quantity: item?.item_batches?.reduce(
  //           //           (sum, batch) =>
  //           //             sum +
  //           //             (parseInt(batch.item_batch_free_quantity, 10) || 0),
  //           //           0
  //           //         ),
  //           //         item_batch_number: item?.item_batch_number,
  //           //         item_schedule: item?.item_schedule,
  //           //         item_discount_amount: parseFloat(
  //           //           item?.item_discount_amount
  //           //         ),
  //           //         item_total_tax_percentage: item?.item_total_tax_percentage,
  //           //         item_tax_amount: parseFloat(item?.item_tax_amount),
  //           //         item_total_amount: item?.item_total_amount,
  //           //         item_id: item?.item_id,
  //           //         ...(item?.sott_id
  //           //           ? { sott_id: item?.sott_id }
  //           //           : { sott_id: null }),
  //           //         ...(item?.srt_id
  //           //           ? { srt_id: item?.srt_id }
  //           //           : { srt_id: null }),
  //           //         item_gst: parseFloat(item?.item_gst),
  //           //         item_sgst: parseFloat(item?.item_sgst||0),
  //           //         item_cgst: parseFloat(item?.item_cgst||0),
  //           //         item_uom_id: item?.item_uom_id ?? "",
  //           //         item_uom: item?.item_uom ?? "",
  //           //         item_manufacturer_id: item?.item_manufacturer_id ?? "",
  //           //         item_manufacturer_name: item?.item_manufacturer_name ?? "",
  //           //         pot_id: item?.pot_id ?? null,
  //           //         pos_id: item?.pos_id ?? null,
  //           //       })),

  //           //       itemBatchData: values.data
  //           //         ?.slice(0, -1)
  //           //         .map((item) => item.item_batches)
  //           //         .flat()
  //           //         .map((batch) => ({
  //           //           item_batch_number: batch?.item_batch_number,
  //           //           item_batch_quantity: parseInt(batch?.item_batch_quantity),
  //           //           item_batch_free_quantity: parseInt(
  //           //             batch?.item_batch_free_quantity
  //           //           ),
  //           //           item_batch_sales_rate: parseFloat(
  //           //             batch?.item_batch_sales_rate
  //           //           ),
  //           //           item_batch_total_base_sales_rate:
  //           //             parseFloat(batch?.item_batch_total_base_sales_rate) ||
  //           //             0,
  //           //           item_batch_discount_percentage:
  //           //             batch?.item_batch_discount_percentage,
  //           //           item_batch_discount_amount: parseFloat(
  //           //             batch?.item_batch_discount_amount
  //           //           ),
  //           //           item_batch_discounted_sales_rate:
  //           //             parseFloat(batch?.item_batch_discounted_sales_rate) ||
  //           //             0,
  //           //           item_batch_tax_percentage:
  //           //             batch?.item_batch_tax_percentage,
  //           //           item_batch_tax_amount: parseFloat(
  //           //             batch?.item_batch_tax_amount
  //           //           ),
  //           //           item_batch_final_sales_rate: parseFloat(
  //           //             batch?.item_batch_final_sales_rate
  //           //           ),
  //           //           item_batch_total_sales_rate: parseFloat(
  //           //             batch?.item_batch_total_sales_rate
  //           //           ),
  //           //           item_batch_unit_price: parseFloat(
  //           //             batch?.item_batch_unit_price
  //           //           ),
  //           //           item_exp_date: batch?.item_exp_date,
  //           //           item_id: batch?.item_id,
  //           //           from_bin_location: batch?.from_bin_location,
  //           //           from_bin_id: batch?.from_bin_id,
  //           //           item_uom: orderDetail?.[0]?.item_uom,
  //           //           item_uom_id: orderDetail?.[0]?.item_uom_id,
  //           //         })),
  //           //     },
  //           //     onSuccessOrder,
  //           //     onErrorOrder
  //           //   )
  //           // );
  //         }, 500);
  //       }
  //     }
  //   }
  // };
  
  // =============================
// FULL handleSubmit with NEW VALIDATIONS
// =============================

// ✅ helper (keep in same file, above handleSubmit)
const validateItemsAndBatches = (values) => {
  const items = values?.data?.slice(0, -1) || [];
  const isDraft = values?.submittedButton === "draft";

  // Keep same behavior style as your existing validations:
  // drafts are lenient (since you already skip qty/uom validations on draft)
  // if (isDraft) return true;

  const toNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : NaN;
  };

  const isEmpty = (v) =>
    v === null ||
    v === undefined ||
    (typeof v === "string" && v.trim() === "");

  // Required batch fields based on your mapping in itemBatchData
  const REQUIRED_BATCH_FIELDS = [
    "item_batch_number",
    "item_batch_quantity",
    "item_batch_free_quantity",
    "item_batch_sales_rate",
    "item_batch_total_base_sales_rate",
    "item_batch_discount_percentage",
    "item_batch_discount_amount",
    "item_batch_discounted_sales_rate",
    "item_batch_tax_percentage",
    "item_batch_tax_amount",
    "item_batch_final_sales_rate",
    "item_batch_total_sales_rate",
    "item_batch_unit_price",
    "item_exp_date",
    "item_id",
  ];

  const NUMERIC_BATCH_FIELDS = [
    "item_batch_quantity",
    "item_batch_free_quantity",
    "item_batch_sales_rate",
    "item_batch_total_base_sales_rate",
    "item_batch_discount_percentage",
    "item_batch_discount_amount",
    "item_batch_discounted_sales_rate",
    "item_batch_tax_percentage",
    "item_batch_tax_amount",
    "item_batch_final_sales_rate",
    "item_batch_total_sales_rate",
    "item_batch_unit_price",
  ];

  const EPS = 0.01;

  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const itemLabel = item?.item_name || item?.item_code || `Item ${i + 1}`;
    const batches = item?.item_batches || [];

    if (!Array.isArray(batches) || batches.length === 0) {
      errorToast(`Please add at least one batch for ${itemLabel}`);
      return false;
    }

    // 1) Every batch must have all fields
    for (let b = 0; b < batches.length; b++) {
      const batch = batches[b];
      const missingKeys = REQUIRED_BATCH_FIELDS.filter((k) => isEmpty(batch?.[k]));
      if (missingKeys.length > 0) {
        errorToast(`Please fill all batch fields for ${itemLabel} (Batch ${b + 1})`);
        return false;
      }

      // ensure numeric fields are valid numbers
      // for (const k of NUMERIC_BATCH_FIELDS) {
      //   const n = toNum(batch?.[k]);
      //   if (!Number.isFinite(n)) {
      //     errorToast(`Invalid ${k} for ${itemLabel} (Batch ${b + 1})`);
      //     return false;
      //   }
      // }
    }

    // 2) Sum of batch totals == item total
    // Using batch.item_batch_total_sales_rate as "batch total amount"
    const sumBatchTotals = batches.reduce(
      (sum, batch) => sum + (toNum(batch?.item_batch_total_sales_rate) || 0),
      0
    );

    const itemTotal = toNum(item?.item_total_amount);
    if (!Number.isFinite(itemTotal)) {
      errorToast(`Invalid item total amount for ${itemLabel}`);
      return false;
    }

    if (Math.abs(sumBatchTotals - itemTotal) > EPS) {
      errorToast(
        `Batch total (${sumBatchTotals.toFixed(2)}) must match item total (${itemTotal.toFixed(
          2
        )}) for ${itemLabel}`
      );
      return false;
    }
  }

  return true;
};

// ✅ ENTIRE handleSubmit
const handleSubmit = (values, actions) => {
  // Block duplicate submissions while a request is already in flight.
  if (isDispatchingRef.current) return;

  console.log(values, "fggdfgdfgdgdfgdfgdfgfdgdg");

  const missingUOM = values?.data?.slice(0, -1).some((item) => !item.item_uom);

  if (!values?.sodtt_pay_to_address) {
    errorToast("Please verify and save the address");
    return;
  }
  if (!values?.sodtt_ship_to_address) {
    errorToast("Please verify and save the address");
    return;
  }

  // ✅ NEW VALIDATIONS (batch completeness + batch totals == item total)
  if (!validateItemsAndBatches(values)) return;

  if (page === "edit") {
    isDispatchingRef.current = true;
    setButtonLoading(true);

    const data = {
      orderData: {
        is_draft_order: values.submittedButton === "draft",
        store_id: storeId,
        ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
        sodtt_total_gst: values?.sodtt_total_gst,
        sodtt_total_discount: values?.sodtt_total_discount,
        sodtt_payment_status: "paid",
        sodtt_transaction_id: "",
        sodtt_billing_address: "",
        sodtt_total_amount: values?.sodtt_total_amount,
        sodtt_sub_total: values?.sodtt_sub_total,
        cmr_code: values?.cmr_code?.label,
        cmr_id: values?.cmr_id,
        cmr_name: values?.cmr_name?.label,
        remarks: values?.remarks,
        sodtt_order_date: values?.sodtt_order_date,
        sodtt_document_date: values?.sodtt_document_date,
        sodtt_delivery_date: values?.sodtt_delivery_date,
        sodtt_reference_invoice_date: values?.sodtt_reference_invoice_date || null,
        cmr_gstin: values?.cmr_gstin || null,
        pot_id: values?.pot_id ?? null,
        pos_id: values?.pos_id ?? values?.sodtt_ship_to_address?.store_id ?? null,
        sodtt_round_off_value: values?.sodtt_round_off_value,
        sodtt_tcs_or_tds_percentage_id: values?.sodtt_tcs_or_tds_percentage_id ?? "",
        sodtt_tcs_or_tds_percentage: values?.sodtt_tcs_or_tds_percentage ?? 0,
        sodtt_tds_tcs_type: values?.sodtt_tds_tcs_type ?? "",
        sodtt_tcs_or_tds_amount: values?.sodtt_tcs_or_tds_amount ?? 0,
        sodtt_is_invoice_dis_percentage: values?.sodtt_is_invoice_dis_percentage,
        sodtt_invoice_discount: Number(values?.sodtt_invoice_discount) ?? 0,
        sodtt_invoice_discount_percentage: Number(values?.sodtt_invoice_discount_percentage) ?? 0,
        sodtt_pay_to_address: values?.sodtt_pay_to_address || null,
        sodtt_ship_to_address: values?.sodtt_ship_to_address || null,
        gst_type:values?.is_inter_state===false?"Intra":"Inter"
      },

      itemData: values?.data
        ?.slice(0, -1)
        .map((item) => ({
          item_code: item?.item_code,
          item_generic_name: item?.item_generic_name,
          item_name: item?.item_name,
          item_hsn: item?.item_hsn,
          ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
          item_quantity: parseInt(item?.quantity),
          item_delivered_quantity: parseInt(item?.quantity),
          item_free_quantity: item?.item_batches?.reduce(
            (sum, batch) => sum + (parseInt(batch?.item_batch_free_quantity, 10) || 0),
            0
          ),
          item_batch_number: item?.item_batch_number,
          item_schedule: item?.item_schedule,
          item_discount_amount: parseFloat(item?.item_discount_amount),
          item_total_tax_percentage: item?.item_total_tax_percentage,
          item_tax_amount: parseFloat(item?.item_tax_amount),
          item_total_amount: item?.item_total_amount,
          item_id: item?.item_id,
          sott_id: item?.sott_id ?? null,
          srt_id: item?.srt_id ?? null,
          base_ref_id: item?.base_ref_id ?? null,
          base_ref_type: item?.base_ref_type ?? null,
          base_ref_line_id: item?.base_ref_line_id ?? null,
          base_ref_doc_number: item?.base_ref_doc_number ?? null,
          item_gst: parseFloat(item?.item_gst),
          item_sgst: values?.is_inter_state===false?parseFloat(item?.item_sgst||0):0,
          item_cgst: values?.is_inter_state===false?parseFloat(item?.item_cgst||0):0,
          item_igst: values?.is_inter_state===true?parseFloat(item?.item_igst||0):0,
          item_uom_id: item?.item_uom_id ?? "",
          item_uom: item?.item_uom ?? "",
          item_manufacturer_id: item?.item_manufacturer_id ?? "",
          item_manufacturer_name: item?.item_manufacturer_name ?? "",
          pot_id: item?.pot_id ?? null,
          pos_id: item?.pos_id ?? values?.pos_id ?? values?.sodtt_ship_to_address?.store_id ?? null,
        })),

      itemBatchData: values?.data
        ?.slice(0, -1)
        .flatMap((item) =>
          item?.item_batches?.map((batch) => ({
            item_batch_number: batch?.item_batch_number,
            item_batch_quantity: parseInt(batch?.item_batch_quantity),
            item_batch_free_quantity: parseInt(batch?.item_batch_free_quantity),
            item_batch_sales_rate: parseFloat(batch?.item_batch_sales_rate),
            ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
            item_batch_total_base_sales_rate: parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
            item_batch_discount_percentage: batch?.item_batch_discount_percentage,
            item_batch_discount_amount: parseFloat(batch?.item_batch_discount_amount),
            item_batch_discounted_sales_rate: parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
            item_batch_tax_percentage: batch?.item_batch_tax_percentage,
            item_batch_tax_amount: parseFloat(batch?.item_batch_tax_amount),
            item_batch_final_sales_rate: parseFloat(batch?.item_batch_final_sales_rate),
            item_batch_total_sales_rate: parseFloat(batch?.item_batch_total_sales_rate),
            item_batch_unit_price: parseFloat(batch?.item_batch_unit_price),
            item_exp_date: batch?.item_exp_date,
            item_id: batch?.item_id,
            from_bin_location: batch?.from_bin_location,
            from_bin_id: batch?.from_bin_id,
            item_uom: item?.item_uom ?? "",
            item_uom_id: item?.item_uom_id ?? "",
            item_batch_ptr_amount:
              parseFloat(batch?.item_batch_ptr_amount) || 0,
            item_batch_pts_amount:
              parseFloat(batch?.item_batch_pts) || 0,
            item_batch_cgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_cgst_percentage):0),
            item_batch_sgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_sgst_percentage):0),
            item_batch_igst_percentage:(values?.is_inter_state===false?0:(batch?.item_batch_igst_percentage)),
            item_batch_cgst_amount:(values?.is_inter_state===false?(batch?.item_batch_cgst_amount):0),
            item_batch_sgst_amount:(values?.is_inter_state===false?(batch?.item_batch_sgst_amount):0),
            item_batch_igst_amount:(values?.is_inter_state===true?(batch?.item_batch_igst_amount):0),
          })) || []
        ),
    };

    dispatch(salesDeliveryEditAction(data, onSuccessOrder, onErrorOrder));
  } else {
    if (
      values?.data?.slice(0, -1).some((item) => parseInt(item.quantity) === 0 || item.quantity === "") &&
      values?.submittedButton !== "draft"
    ) {
      errorToast("Quantity cannot be zero");
    } else if (missingUOM && values?.submittedButton !== "draft") {
      errorToast("Please add UOM for all items");
    } else {
      if (values?.data?.length > 1) {
        isDispatchingRef.current = true;
        setButtonLoading(true);

        setTimeout(() => {
          const data = {
            orderData: {
              is_draft_order: values.submittedButton === "draft",
              store_id: storeId,
              ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
              sodtt_total_gst: values?.sodtt_total_gst,
              sodtt_total_discount: values?.sodtt_total_discount,
              sodtt_payment_status: "paid",
              sodtt_transaction_id: "",
              sodtt_billing_address: "",
              sodtt_total_amount: values?.sodtt_total_amount,
              sodtt_sub_total: values?.sodtt_sub_total,
              cmr_code: values?.cmr_code?.label,
              cmr_id: values?.cmr_id,
              cmr_name: values?.cmr_name?.label,
              remarks: values?.remarks,
              sodtt_order_date: values?.sodtt_order_date,
              sodtt_document_date: values?.sodtt_document_date,
              sodtt_delivery_date: values?.sodtt_delivery_date,
              sodtt_reference_invoice_date: values?.sodtt_reference_invoice_date || null,
              cmr_gstin: values?.cmr_gstin || null,
              pot_id: values?.pot_id ?? null,
              pos_id: values?.pos_id ?? values?.sodtt_ship_to_address?.store_id ?? null,
              sodtt_round_off_value: values?.sodtt_round_off_value,
              sodtt_tcs_or_tds_percentage_id: values?.sodtt_tcs_or_tds_percentage_id ?? "",
              sodtt_tcs_or_tds_percentage: values?.sodtt_tcs_or_tds_percentage ?? 0,
              sodtt_tds_tcs_type: values?.sodtt_tds_tcs_type ?? "",
              sodtt_tcs_or_tds_amount: values?.sodtt_tcs_or_tds_amount ?? 0,
              sodtt_is_invoice_dis_percentage: values?.sodtt_is_invoice_dis_percentage,
              sodtt_invoice_discount: Number(values?.sodtt_invoice_discount) ?? 0,
              sodtt_invoice_discount_percentage: Number(values?.sodtt_invoice_discount_percentage) ?? 0,
              sodtt_pay_to_address: values?.sodtt_pay_to_address || null,
              sodtt_ship_to_address: values?.sodtt_ship_to_address || null,
              gst_type:values?.is_inter_state===false?"Intra":"Inter"
            },

            itemData: values?.data
              ?.slice(0, -1)
              .map((item) => ({
                item_code: item?.item_code,
                item_generic_name: item?.item_generic_name,
                item_name: item?.item_name,
                item_hsn: item?.item_hsn,
                item_quantity: parseInt(item?.quantity),
                item_delivered_quantity: parseInt(item?.quantity),
                item_free_quantity: item?.item_batches?.reduce(
                  (sum, batch) => sum + (parseInt(batch.item_batch_free_quantity, 10) || 0),
                  0
                ),
                item_batch_number: item?.item_batch_number,
                item_schedule: item?.item_schedule,
                item_discount_amount: parseFloat(item?.item_discount_amount),
                item_total_tax_percentage: item?.item_total_tax_percentage,
                item_tax_amount: parseFloat(item?.item_tax_amount),
                item_total_amount: item?.item_total_amount,
                item_id: item?.item_id,
                sott_id: item?.sott_id ?? null,
                srt_id: item?.srt_id ?? null,
                base_ref_id: item?.base_ref_id ?? null,
                base_ref_type: item?.base_ref_type ?? null,
                base_ref_line_id: item?.base_ref_line_id ?? null,
                base_ref_doc_number: item?.base_ref_doc_number ?? null,
                item_gst: parseFloat(item?.item_gst),
                item_sgst: values?.is_inter_state===false?parseFloat(item?.item_sgst||0):0,
                item_cgst: values?.is_inter_state===false?parseFloat(item?.item_cgst||0):0,
                item_igst: values?.is_inter_state===true?parseFloat(item?.item_igst||0):0,
                item_uom_id: item?.item_uom_id ?? "",
                item_uom: item?.item_uom ?? "",
                item_manufacturer_id: item?.item_manufacturer_id ?? "",
                item_manufacturer_name: item?.item_manufacturer_name ?? "",
                pot_id: item?.pot_id ?? null,
                pos_id: item?.pos_id ?? values?.pos_id ?? values?.sodtt_ship_to_address?.store_id ?? null,
              })),

            itemBatchData: values?.data
              ?.slice(0, -1)
              .flatMap((item) =>
                item.item_batches.map((batch) => ({
                  item_batch_number: batch?.item_batch_number,
                  item_batch_quantity: parseInt(batch?.item_batch_quantity),
                  item_batch_free_quantity: parseInt(batch?.item_batch_free_quantity),
                  item_batch_sales_rate: parseFloat(batch?.item_batch_sales_rate),
                  item_batch_total_base_sales_rate: parseFloat(batch?.item_batch_total_base_sales_rate) || 0,
                  item_batch_discount_percentage: batch?.item_batch_discount_percentage,
                  item_batch_discount_amount: parseFloat(batch?.item_batch_discount_amount),
                  item_batch_discounted_sales_rate: parseFloat(batch?.item_batch_discounted_sales_rate) || 0,
                  item_batch_tax_percentage: batch?.item_batch_tax_percentage,
                  item_batch_tax_amount: parseFloat(batch?.item_batch_tax_amount),
                  item_batch_final_sales_rate: parseFloat(batch?.item_batch_final_sales_rate),
                  item_batch_total_sales_rate: parseFloat(batch?.item_batch_total_sales_rate),
                  item_batch_unit_price: parseFloat(batch?.item_batch_unit_price),
                  item_exp_date: batch?.item_exp_date,
                  item_id: batch?.item_id,
                  from_bin_location: batch?.from_bin_location,
                  from_bin_id: batch?.from_bin_id,
                  item_uom: item?.item_uom ?? "",
                  item_uom_id: item?.item_uom_id ?? "",
                  item_batch_cgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_cgst_percentage):0),
                  item_batch_sgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_sgst_percentage):0),
                  item_batch_igst_percentage:(values?.is_inter_state===false?0:(batch?.item_batch_igst_percentage)),
                  item_batch_cgst_amount:(values?.is_inter_state===false?(batch?.item_batch_cgst_amount):0),
                  item_batch_sgst_amount:(values?.is_inter_state===false?(batch?.item_batch_sgst_amount):0),
                  item_batch_igst_amount:(values?.is_inter_state===true?(batch?.item_batch_igst_amount):0),
                  item_batch_ptr_amount:
                    parseFloat(batch?.item_batch_ptr_amount) || 0,
                  item_batch_pts_amount:
                    parseFloat(batch?.item_batch_pts) || 0,
                }))
              ),
          };
          dispatch(salesDeliveryReceiptCreateAction(data, onSuccessOrder, onErrorOrder));
        }, 500);
      }
    }
  }
};


  const onSuccessOrder = (data) => {
    isDispatchingRef.current = false;
    setButtonLoading(false);

    if (formValues?.submittedButton === "print") {
      handlea4Print(
        data?.data?.orderData?.sodtt_id,
        "sales_delivery",
        dispatch
      );
    }
    navigate("/sales-delivery");
    successToast(data?.message);
    setInitialValue({
      cmr_code: "",
      cmr_name: "",
      cmr_id: "",
      remarks: "",
      sodtt_total_discount: 0,
      sodtt_order_date: null,
      sodtt_document_date: null,
      sodtt_delivery_date: null,
      data: [initialData],
    });
  };
  const onErrorOrder = (data) => {
    errorToast(data?.data?.message);

    isDispatchingRef.current = false;
    setButtonLoading(false);
  };

  useHotkeys("escape", () => {
    setAddbatch(false);
  });

  const autoDraft = (values) => {
    if (isDispatchingRef.current) return;
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    if (
      page === "edit" &&
      values?.submittedButton !== "draft" &&
      values?.sodtt_order_status !== "draft"
    ) {
      isDispatchingRef.current = true;
      setButtonLoading(true);

      dispatch(
        salesDeliveryEditAction(
          {
            is_draft_order: values.submittedButton === "draft" ? true : false,
            only_remarks: true,
            sodtt_id: values?.sodtt_id,
            remarks: values?.remarks,
          },
          onSuccessOrder,
          onErrorOrder
        )
      );
    } else {
      if (
        values?.data
          ?.slice(0, -1)
          .some(
            (item) => parseInt(item.quantity) === 0 || item.quantity === ""
          ) &&
        values?.submittedButton !== "draft"
      ) {
        errorToast("Quantity cannot be zero");
      } else if (missingUOM && values?.submittedButton !== "draft") {
        errorToast("Please add UOM for all items");
      } else {
        const hasItems = (values?.data?.length ?? 0) > 1;
        if (hasItems) {
          isDispatchingRef.current = true;
          setButtonLoading(true);
          setTimeout(() => {
            dispatch(
              salesDeliveryReceiptCreateAction(
                {
                  orderData: {
                    is_draft_order: true,
                    store_id: storeId,
                    ...(values?.sodtt_id ? { sodtt_id: values?.sodtt_id } : {}),
                    sodtt_total_gst: values?.sodtt_total_gst,
                    sodtt_total_discount: values?.sodtt_total_discount,
                    sodtt_payment_status: "paid",
                    sodtt_transaction_id: "",
                    sodtt_billing_address: "",
                    sodtt_total_amount: values?.sodtt_total_amount,
                    sodtt_sub_total: values?.sodtt_sub_total,
                    cmr_code: values?.cmr_code?.label,
                    cmr_id: values?.cmr_id,
                    cmr_name: values?.cmr_name?.label,
                    remarks: values?.remarks,
                    sodtt_order_date: values?.sodtt_order_date,
                    sodtt_document_date: values?.sodtt_document_date,
                    sodtt_delivery_date: values?.sodtt_delivery_date,
                    sodtt_reference_invoice_date: values?.sodtt_reference_invoice_date || null,
                    cmr_gstin: values?.cmr_gstin || null,
                    pot_id: values?.pot_id ?? null,
                    pos_id: values?.pos_id ?? null,
                    sodtt_round_off_value: values?.sodtt_round_off_value,
                    sodtt_tcs_or_tds_percentage_id:
                      values?.sodtt_tcs_or_tds_percentage_id ?? "",
                    sodtt_tcs_or_tds_percentage:
                      values?.sodtt_tcs_or_tds_percentage ?? 0,
                    sodtt_tds_tcs_type: values?.sodtt_tds_tcs_type ?? "",
                    sodtt_tcs_or_tds_amount:
                      values?.sodtt_tcs_or_tds_amount ?? 0,
                    // customer_invoice_number: values?.customer_invoice_number,
                    sodtt_is_invoice_dis_percentage:
                      values?.sodtt_is_invoice_dis_percentage,
                    sodtt_invoice_discount:
                      Number(values?.sodtt_invoice_discount) ?? 0,
                    sodtt_invoice_discount_percentage:
                      Number(values?.sodtt_invoice_discount_percentage) ?? 0,
                    sodtt_pay_to_address: values?.sodtt_pay_to_address || null, //new
                    gst_type:values?.is_inter_state===false?"Intra":"Inter",
                    sodtt_ship_to_address:
                      values?.sodtt_ship_to_address || null, //new
                  },
                  itemData: values?.data?.slice(0, -1).map((item, index) => ({
                    item_code: item?.item_code,
                    item_generic_name: item?.item_generic_name,
                    item_name: item?.item_name,
                    item_hsn: item?.item_hsn,
                    item_quantity: parseInt(item?.quantity),
                    item_delivered_quantity: parseInt(item?.quantity),
                    item_free_quantity: item?.item_batches?.reduce(
                      (sum, batch) =>
                        sum +
                        (parseInt(batch.item_batch_free_quantity, 10) || 0),
                      0
                    ),
                    item_batch_number: item?.item_batch_number,
                    item_schedule: item?.item_schedule,
                    item_discount_amount: parseFloat(
                      item?.item_discount_amount
                    ),
                    item_total_tax_percentage: item?.item_total_tax_percentage,
                    item_tax_amount: parseFloat(item?.item_tax_amount),
                    item_total_amount: item?.item_total_amount,
                    item_id: item?.item_id,
                    ...(item?.sott_id
                      ? { sott_id: item?.sott_id }
                      : { sott_id: null }),
                    ...(item?.srt_id
                      ? { srt_id: item?.srt_id }
                      : { srt_id: null }),
                    base_ref_id: item?.base_ref_id ?? null,
                    base_ref_type: item?.base_ref_type ?? null,
                    base_ref_line_id: item?.base_ref_line_id ?? null,
                    base_ref_doc_number: item?.base_ref_doc_number ?? null,
                    item_gst: parseFloat(item?.item_gst),
                    item_sgst: values?.is_inter_state===false?parseFloat(item?.item_sgst||0):0,
                    item_cgst: values?.is_inter_state===false?parseFloat(item?.item_cgst||0):0,
                    item_igst: values?.is_inter_state===true?parseFloat(item?.item_igst||0):0,
                    item_uom_id: item?.item_uom_id ?? "",
                    item_uom: item?.item_uom ?? "",
                    item_manufacturer_id: item?.item_manufacturer_id ?? "",
                    item_manufacturer_name: item?.item_manufacturer_name ?? "",
                    pot_id: item?.pot_id ?? null,
                    pos_id: item?.pos_id ?? values?.pos_id ?? values?.sodtt_ship_to_address?.store_id ?? null,
                  })),

                  itemBatchData: values.data
                    ?.slice(0, -1)
                    .map((item) => item.item_batches)
                    .flat()
                    .map((batch) => ({
                      item_batch_number: batch?.item_batch_number,
                      item_batch_quantity: parseInt(batch?.item_batch_quantity),
                      item_batch_free_quantity: parseInt(
                        batch?.item_batch_free_quantity
                      ),
                      item_batch_sales_rate: parseFloat(
                        batch?.item_batch_sales_rate
                      ),
                      item_batch_total_base_sales_rate:
                        parseFloat(batch?.item_batch_total_base_sales_rate) ||
                        0,
                      item_batch_discount_percentage:
                        batch?.item_batch_discount_percentage,
                      item_batch_discount_amount: parseFloat(
                        batch?.item_batch_discount_amount
                      ),
                      item_batch_discounted_sales_rate:
                        parseFloat(batch?.item_batch_discounted_sales_rate) ||
                        0,
                      item_batch_tax_percentage:
                        batch?.item_batch_tax_percentage,
                      item_batch_tax_amount: parseFloat(
                        batch?.item_batch_tax_amount
                      ),
                      item_batch_final_sales_rate: parseFloat(
                        batch?.item_batch_final_sales_rate
                      ),
                      item_batch_total_sales_rate: parseFloat(
                        batch?.item_batch_total_sales_rate
                      ),
                      item_batch_unit_price: parseFloat(
                        batch?.item_batch_unit_price
                      ),
                      item_exp_date: batch?.item_exp_date,
                      item_id: batch?.item_id,
                      from_bin_location: batch?.from_bin_location,
                      from_bin_id: batch?.from_bin_id,
                      item_uom: orderDetail?.[0]?.item_uom,
                      item_uom_id: orderDetail?.[0]?.item_uom_id,
                      item_batch_cgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_cgst_percentage):0),
                      item_batch_sgst_percentage:(values?.is_inter_state===false?(batch?.item_batch_sgst_percentage):0),
                      item_batch_igst_percentage:(values?.is_inter_state===false?0:(batch?.item_batch_igst_percentage)),
                      item_batch_cgst_amount:(values?.is_inter_state===false?(batch?.item_batch_cgst_amount):0),
                      item_batch_sgst_amount:(values?.is_inter_state===false?(batch?.item_batch_sgst_amount):0),
                      item_batch_igst_amount:(values?.is_inter_state===true?(batch?.item_batch_igst_amount):0),
                    })),
                },
                (data) => {
                  successToast(data?.message);
                  // setLoading(true);
                  setTimeout(() => {
                    // setLoading(false);
                  }, 50);
                  navigate(
                    `/edit-customer-admin/${values?.cmr_id}?backto=/edit-delivery/${data?.data?.orderData?.sodtt_id}?new`,
                    {
                      state: { tab: "Address" },
                    }
                  );
                },
                (data) => {
                  errorToast(data?.data?.message);
                }
              )
            );
          }, 500);
        } else {
          navigate(
            `/edit-customer-admin/${values?.cmr_id}?backto=/add-delivery/%255B%255D/delivery?new`,
            {
              state: { tab: "Address" },
            }
          );
        }
      }
    }
  };
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValue}
      validationSchema={validationSchema}
      onSubmit={(values, actions) => {
        if (submitScheduledRef.current || isDispatchingRef.current) {
          actions.setSubmitting(false);
          return;
        }
        submitScheduledRef.current = true;
        setButtonLoading(true);
        handleSubmit(values, actions); // arms isDispatchingRef on dispatch
        submitScheduledRef.current = false;
        if (!isDispatchingRef.current) {
          setButtonLoading(false);
        }
        actions.setSubmitting(false); // Notify Formik that submission is done
      }}
    >
      {({ values }) => {
        // setFormValues(values);
        console.log(values, "lll");

        return (
          <Form className="h-full">
            {console.log("rrr", values)}
            {/* <UpdateShipto shipto={shipto} /> */}
            <UpdatePayto vendorDetails={vendorDetails} />
            <div
              style={{
                height: `calc(100% - 8rem)`,
              }}
              className="mx-5 flex flex-col h-full "
            >
              <SalesBatchesPanel
                searchRef={searchRef}
                open={addbatch}
                disabled={disabled}
                setItemId={setItemId}
                itemId={itemId}
                setOpen={setAddbatch}
                itemValues={values}
                prefix="sodtt"
              />
              <SalesPurchaseNavbar
                isClone={isClone}
                autoDraft={autoDraft}
                clickedplus={clickedplus}
                pageType={pageType}
                pageName="sales delivery"
                page={page}
                isCusInvNumRequired={false}
                section="sales"
                name="sodtt"
                disabled={disabled}
                searchRef={searchRef}
                storeDetails={storeDetails}
                transfer={transfer}
                standAlone={standAlone}
              />
              <SalesItemsSection
                isClone={isClone}
                auto={auto}
                heading={heading}
                standAlone={standAlone}
                disName="sodtt_total_discount"
                type={type}
                disabled={values.is_inter_state===null || disabled}
                addBatchFn={(id) => {
                  setAddbatch(true);
                  setItemId(id);
                }}
                searchRef={searchRef}
                initialData={initialData}
                prefixName="sodtt"
                isNotViewOnly={isNotViewOnly}
                clickedplus={clickedplus}
                itemValues={values}
              />
            </div>
            <SalesPurchaseFooter
              modules="sales"
              transaction="Delivery Note"
              transaction_type="sales_delivery"
              buttonLoading={buttonLoading}
              name="sodtt_total_discount"
              page={page}
              disabled={disabled}
              EditFn={() =>
                navigate(`/edit-delivery/${vendorDetails?.[0]?.sodtt_id}`)
              }
              prefixName="sodtt"
              tcsTdsAmount={tcsTdsAmount}
              setTcsTdsAmount={setTcsTdsAmount}
            />
          </Form>
        );
      }}
    </Formik>
  );
};

export default CreateEditViewSalesDelivery;

function UpdateShipto({ shipto }) {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    // console.log("///", shipto);
    if (shipto) {
      setFieldValue("sodtt_ship_to_address", shipto);
    }
  }, [shipto]);

  return null;
}

function UpdatePayto({ vendorDetails }) {
  const { values, setFieldValue } = useFormikContext();
  console.log("///", vendorDetails);

  useEffect(() => {
    // setFieldValue("sodtt_pay_to_address", vendorDetails.sott_pay_to_address);
    // setFieldValue("sodtt_ship_to_address", vendorDetails.sott_ship_to_address);
  }, [vendorDetails]);

  return null;
}
